export class GeolocationIofesign {
  id: number;
  personId: number;
  documentId: number;
  signatureType: string;
  ip: string;
  identification: string;
  timeStamp: string;
  longTime: string;
  timeZone: string;
  latitude: string;
  longitude: string;
  accuracy: string;
  evidence: string;
  active: boolean;
  deleted: boolean;
}
